import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

export type LandingPage =
    | 'home'
    | 'immobilien'
    | 'faq'
    | 'about'
    | 'impressum'
    | 'widerruf'
    | 'ratgeber';

const PATHS: Record<'de' | 'en', Record<LandingPage, string>> = {
    de: {
        home: '/',
        immobilien: '/immobilien',
        faq: '/faq',
        about: '/ueber-uns',
        impressum: '/impressum',
        widerruf: '/widerruf',
        ratgeber: '/ratgeber',
    },
    en: {
        home: '/en',
        immobilien: '/en/real-estate',
        faq: '/en/faq',
        about: '/en/about-us',
        impressum: '/en/imprint',
        widerruf: '/en/withdrawal',
        ratgeber: '/en/guide',
    },
};

/**
 * Links auf die Landingpage (Astro, Ordner `landing/`).
 *
 * Die Landingpage wird nicht mehr von Angular gerendert. Jeder Link dorthin ist deshalb ein
 * echter Seitenwechsel (`href` bzw. `window.location`), kein `routerLink` – sonst versucht
 * der Angular-Router, eine Route zu rendern, die es nicht mehr gibt.
 * Die Pfade folgen der aktiven Sprache (DE ohne Präfix, EN unter `/en`).
 */
@Injectable({ providedIn: 'root' })
export class LandingLinkService {
    constructor(private transloco: TranslocoService) {}

    href(page: LandingPage, fragment?: string): string {
        const lang = this.transloco.getActiveLang() === 'en' ? 'en' : 'de';
        return PATHS[lang][page] + (fragment ? `#${fragment}` : '');
    }

    go(page: LandingPage, fragment?: string): void {
        window.location.assign(this.href(page, fragment));
    }
}
